import { atom } from 'recoil'

export const modalUsedMessageState = atom({
  key: 'abtestmodalUsedMessageState',
  default: {
    show: false,
    entityName: '',
    entityType: '',
    type: undefined, // WORKFLOW_MESSAGE_TYPE_EMAIL/WORKFLOW_MESSAGE_TYPE_SMS,
    droppableId: ''
  }
})

export const modalCheckupState = atom({
  key: 'abtestModalCheckupStateABTest',
  default: {
    show: false,
    checkupArrayResp: [],
    error: false
  }
})

export const modalFilterDetailState = atom({
  key: 'abtestWizardModalFilterDetails',
  default: {
    show: false
  }
})

export const modalColumnsManagementState = atom({
  key: 'abtestgWizardModalColumnsManagementsState',
  default: {
    show: false
  }
})
